import { render, staticRenderFns } from "./dissertation-project.pug?vue&type=template&id=1de87e22&lang=pug&"
import script from "./dissertation-project.ts?vue&type=script&lang=ts&"
export * from "./dissertation-project.ts?vue&type=script&lang=ts&"
import style0 from "./dissertation-project.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports